
<custom-host-names
  :custom-host-names="customHostNames"
  :loading="loading"
  @onVerifyCustomHostName="verifyCustomHostnames()"
></custom-host-names>
